import { gql } from '@apollo/client';

const LABEL_FRAGMENT = gql`
  fragment LabelFragment on ShipmentLabel {
    id
    shipmentDate
    transaction {
      id
      trackingNumber
      trackingUrlProvider
      eta
    }
    rate {
      id
      carrier
      carrierLogo200
    }
    tracking {
      trackingHistory {
        status
        statusDate
        location {
          street1
          city
          state
          country
        }
        statusDetails
      }
    }
  }
`;

export default LABEL_FRAGMENT;
